<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="period_id" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('periods')">
                                    <payment-periods-selectbox
                                        v-model="defineForm.period_id"
                                        :validateError="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
<!--                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <b-table class="mt-2 mb-2" borderless small bordered responsive thead-tr-class="table-success" :items="tableItems" :fields="tableFields"></b-table>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <b-button @click="download('scholarships_import')" variant="outline-secondary" class="mr-2">{{ $t('download_excel_template') }}</b-button>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>

                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component


// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import JobService from "@/services/JobService";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox"
import excelImportTemplate from "@/services/ExcelImportTemplate";

export default {
    components: {

        ValidationProvider,
        ValidationObserver,
        PaymentPeriodsSelectbox
    }
    ,
    data() {
        return {
            defineForm: {
                semester_id: null,
                file: null,
                period_id: null
            },
            loading: false,
            tableFields: [
                {
                    key: 'student_number',
                    label: this.$t('student_number'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'program_code',
                    label: this.$t('program_code'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'scholarship_code',
                    label: this.$t('scholarship_code'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'scholarship_rate',
                    label: this.$t('scholarship_rate'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'time_scholarship',
                    label: this.$t('time_scholarship'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'description',
                    label: this.$t('description'),
                    tdClass: 'border text-center',
                },
            ],
            tableItems: [
                {
                    student_number: this.$t('student_number'),
                    program_code: this.$t('program_code'),
                    scholarship_code: this.$t('scholarship_code'),
                    scholarship_rate: this.$t('scholarship_rate'),
                    time_scholarship: this.$t('time_scholarship'),
                    description: this.$t('description'),
                },
            ]
        }
    }
    ,
    methods: {
        async sendForm() {
            const isValid = await this.$refs.updateForm.validate();
            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])
                formData.append('period_id', this.defineForm.period_id)
                return JobService.scholarshipsImport(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                        this.$emit('successProcess',true)
                    })
                    .catch(e => {
                        this.showErrors(e,this.$refs.updateForm)
                    })
            }
        },
        download(code) {
            excelImportTemplate.downloadTemplate(code)
                .then(response => {
                    this._downloadFile(response, code + '.xlsx')
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$toast.error(error.data.errors.file[0]);
                    }
                    if (error.status == 406) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                });
        },
    }
}
</script>
